import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-ai-agent',
  templateUrl: './ai-agent.component.html',
  styleUrls: ['./ai-agent.component.scss'],
})
export class AiAgentComponent implements OnInit {
  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    // this.loadLogoChatWidget();
    this.loadElevenLabsWidget();
  }

  private loadLogoChatWidget(): void {
    if (
      (window as any).ChatWidgetConfig ||
      document.querySelector('script[src*="n8n-chat-widget"]')
    ) {
      return;
    }

    (window as any).ChatWidgetConfig = {
      webhookUrl: 'https://n8n.mylogoinc.app/webhook/logo-customer',
      route: 'general',
      title: 'LOGO Cargo 📦',
      greeting: 'Hi 👋, how can we help?',
      position: 'right',
      style: {
        primaryColor: '#22c55e',
        secondaryColor: '#16a34a',
        backgroundColor: '#ffffff',
        fontColor: '#1f2937',
      },
    };

    const script = this.renderer.createElement('script');
    script.src = 'https://cdn.mylogoinc.app/n8n-chat-widget.js';
    script.defer = true;
    script.type = 'text/javascript';

    this.renderer.appendChild(document.body, script);
  }

  private loadElevenLabsWidget(): void {
    if (!document.querySelector('script[src*="convai-widget-embed"]')) {
      const script = this.renderer.createElement('script');
      script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
      script.async = true;
      script.type = 'text/javascript';

      this.renderer.appendChild(document.body, script);
    }
  }
}
